import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    index?: string
    children: ReactNode
    className?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ index, children, className }): ReactNode => (
    <p className={cn('t-label flex items-center gap-3 text-tone-muted', className)}>
        {index && <span className='tabular text-tone-ink'>{index}</span>}
        {index && <span className='h-px w-8 bg-current opacity-40' aria-hidden='true' />}
        <span>{children}</span>
    </p>
)
